// extracted by mini-css-extract-plugin
export var circle = "_ff-1";
export var exitConfirmationModal = "_ff-5";
export var iframe = "_ff-0";
export var offline = "_ff-3";
export var online = "_ff-2";
export var workstationSelectError = "_ff-4";